---
pageId: concept-categories
title: Categories
description: Categories group your trackers into a hierarchy, give them a shared color, and power recursive filtering across the Journal and Stats.
category: concepts
order: 3
lang: en
slug: concepts/categories
updated: 2026-08-05
---

Categories keep a growing set of trackers organized. Each category has a name, a color and an optional emoji icon — and categories nest, so "Health" can hold "Sleep" and "Nutrition" as subcategories with their own trackers.

## Color flows down, icons don't

A tracker without its own color inherits the color of its category. Set a tracker's color to override it; clear it to fall back to the category again. That single rule keeps the Journal, the quick-add picker and the stats visually consistent without per-tracker fiddling.

Icons do not cascade — each tracker shows its own icon, or a neutral glyph tinted with its effective color.

## Managing categories

Everything happens in **Settings → Category Management**. The panel shows your categories as a tree with their trackers nested inside, and an **Uncategorized** section at the bottom for trackers without a home.

- **Add Category** creates a top-level category; every category's menu offers **Add subcategory**, **Edit category** and **Delete category**.
- **Drag and drop** does the heavy lifting: drop a category onto another to nest it, above or below to reorder, or onto the root zone to make it top-level. Drag a tracker onto a category to move it, or onto the root zone to uncategorize it.
- Editing a category exposes its name, color and emoji. You can also adjust a tracker's color and emoji inline, right in the tree.

Deleting a category is non-destructive to your data: its subcategories move up to the deleted category's parent, and its trackers become uncategorized.

## Filtering is recursive

Filtering by a category always includes its whole subtree — select "Health" and entries from "Sleep" and "Nutrition" trackers are included automatically. This applies to the Journal timeline and to the filters on the Stats page.

## Plan limits

The Free plan includes 2 categories; Pro removes the limit.
